<!--
 * @Author: zcc zcc-2578840576 2578840576@qq.com
 * @Date: 2026-03-10 11:12:26
 * @LastEditors: zcc zcc-2578840576 2578840576@qq.com
 * @LastEditTime: 2026-03-10 11:55:04
 * @FilePath: \hzs-nutra-wecom-shop\src\views\BuyerProxyPayment\takeOrderType.vue
 * @Description:代客下单 - 选择下单类型
-->

<template>
  <div class="customer-container">
    <div class="welcome-section">
      <div class="customer-buttons">
        <div class="customer-button btn1" @click="openwxminapp(1)">
          <div class="button-content">
            <div class="button-text">下单普通商品</div>
          </div>
        </div>

        <div class="customer-button btn2" @click="openwxminapp(2)">
          <div class="button-content">
            <div class="button-text">兑换积分商品</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import authApi from "@/utils/api/auth";
import * as ww from '@wecom/jssdk'
import { showToast } from 'vant'
import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router';
const router = useRouter();
const route = useRoute();
const user_uuid = route.query.user_uuid;

onMounted(() => {
  authApi.initWeWorkConfig();
})
//代客下单跳转到小程序
const openwxminapp = async (type) => {
  // const targetUrl = window.location.origin + '/orderlist?order_type=1';
  // window.history.replaceState(null, '', targetUrl);
  const shop_clerk_uuid = localStorage.getItem('shop_clerk_uuid');
  const departmentdata = JSON.parse(localStorage.getItem('departmentdata'));
  //跳转微信小程序
  const path = type === 1 ? `pages/goods/proxy_list?clerkuuid=${shop_clerk_uuid}&user_uuid=${user_uuid}&shopuuid=${departmentdata.department_uuid}` : `pages/score/scoreshop?clerkuuid=${shop_clerk_uuid}&user_uuid=${user_uuid}&shopuuid=${departmentdata.department_uuid}`
  console.log(path) 
  ww.launchMiniprogram({
    appid: import.meta.env.VITE_WX_MINI_APPID,
    path: path,
    envVersion: 'release',//release 正式版，trial 体验版，developer 开发版
    success: function (res) {
      console.log('launchMiniprogram success', res)
      router.push('/orderlist?order_type=1');
    },
    fail: function (res) {
      console.log('launchMiniprogram fail', res)
    }
  })
}

</script>

<style lang="less" scoped>
.customer-container {
  min-height: 100vh;
  padding-bottom: 70px;
}

/* 欢迎语区域 */
.welcome-section {
  padding: 28px 17px;
  position: relative;
  background-image: url("@/assets/img/customer/cus-1.png");
  background-size: 100% auto;
  background-position: top;
  background-repeat: no-repeat;
  margin-bottom: 13px;
}

/* 客户按钮区域 */
.customer-buttons {
  padding: 0 17px;

  .customer-button {
    height: 163px;
    border-radius: 11px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin-bottom: 13px;

    .button-content {
      height: 163px;
      padding-left: 32px;

      .button-text {
        height: 100%;
        font-family:
          PingFang SC,
          PingFang SC;
        font-weight: 600;
        font-size: 24px;
        line-height: 163px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }
    &.btn1 {
      background-image: url("@/assets/img/customer/cus-3.png");
    }
    &.btn1 .button-text {
      color: #654317;
    }
    &.btn2 {
      background-image: url("@/assets/img/customer/cus-5.png");
    }
    &.btn2 .button-text {
      color: #0f4e1b;
    }
  }

  .store-customer-btn {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    background-image: url("@/assets/img/customer/cus-4.png");
    background-size: 100% auto;
    background-repeat: no-repeat;

    .button-content {
      line-height: 140px;
      padding-left: 19px;

      .button-text {
        font-size: 23px;
        color: #255959;
        font-weight: 500;
      }
    }
  }
}
</style>
